import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { fmt$, fmt$0 } from '../utils/formatters';

export default function PriceTrends({t,si,sb,sh,sd,mn,orgId,ings}){
const[history,setHistory]=useState([]);const[loading,setLoading]=useState(true);
const[search,setSearch]=useState("");const[selId,setSelId]=useState(null);

useEffect(()=>{if(!orgId)return;loadHistory();},[orgId]);

async function loadHistory(){
  setLoading(true);
  const{data}=await supabase.from('price_history').select('*').eq('org_id',orgId).order('changed_at',{ascending:false}).limit(2000);
  setHistory(data||[]);setLoading(false);
}

// Aggregate: latest change per ingredient
const byIng={};
history.forEach(h=>{
  if(!byIng[h.ingredient_id])byIng[h.ingredient_id]={changes:[],first:h,latest:h};
  byIng[h.ingredient_id].changes.push(h);
  if(h.changed_at>byIng[h.ingredient_id].latest.changed_at)byIng[h.ingredient_id].latest=h;
  if(h.changed_at<byIng[h.ingredient_id].first.changed_at)byIng[h.ingredient_id].first=h;
});

// Top increases and decreases by latest change
const withPct=Object.entries(byIng).map(([id,d])=>{
  const ig=ings.find(x=>x.id===id);
  const pct=d.latest.old_price>0?((d.latest.new_price-d.latest.old_price)/d.latest.old_price*100):0;
  return{id,name:ig?.n||id,pct,latest:d.latest,changes:d.changes,first:d.first};
}).filter(x=>Math.abs(x.pct)>0.1);

const topIncreases=[...withPct].filter(x=>x.pct>0).sort((a,b)=>b.pct-a.pct).slice(0,10);
const topDecreases=[...withPct].filter(x=>x.pct<0).sort((a,b)=>a.pct-b.pct).slice(0,10);
const avgChange=withPct.length?withPct.reduce((s,x)=>s+x.pct,0)/withPct.length:0;

// Search
const searchResults=search.length>=2?ings.filter(i=>i.n.toLowerCase().includes(search.toLowerCase())||i.b?.toLowerCase().includes(search.toLowerCase())).slice(0,15):[];

// Selected ingredient chart
const selChanges=selId?byIng[selId]?.changes||[]:[];
const selIng=selId?ings.find(x=>x.id===selId):null;
const selSorted=[...selChanges].sort((a,b)=>a.changed_at.localeCompare(b.changed_at));
const selMax=selSorted.length?Math.max(...selSorted.map(d=>Math.max(d.old_price,d.new_price))):0;
const selMin=selSorted.length?Math.min(...selSorted.map(d=>Math.min(d.old_price,d.new_price))):0;
const selRange=selMax-selMin||1;

return(<div>
<h1 style={{fontSize:22,fontWeight:700,margin:"0 0 20px"}}>Price Trends</h1>

{loading?<div style={{color:t.td,padding:20}}>Loading price history...</div>:<>

{/* Summary cards */}
<div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:14,marginBottom:20}}>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:"16px 18px"}}>
<div style={{fontSize:10,color:t.tm,textTransform:"uppercase",marginBottom:6}}>Items Tracked</div>
<div style={{fontSize:22,fontWeight:700,fontFamily:mn,color:t.bl}}>{Object.keys(byIng).length}</div>
</div>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:"16px 18px"}}>
<div style={{fontSize:10,color:t.tm,textTransform:"uppercase",marginBottom:6}}>Total Changes</div>
<div style={{fontSize:22,fontWeight:700,fontFamily:mn,color:t.yl}}>{history.length}</div>
</div>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:"16px 18px"}}>
<div style={{fontSize:10,color:t.tm,textTransform:"uppercase",marginBottom:6}}>Avg Price Change</div>
<div style={{fontSize:22,fontWeight:700,fontFamily:mn,color:avgChange>0?t.ac:avgChange<0?t.gn:t.td}}>{avgChange>0?"+":""}{avgChange.toFixed(1)}%</div>
</div>
</div>

{/* Top increases and decreases side by side */}
<div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:18}}>
<div style={{fontSize:13,fontWeight:600,marginBottom:12,color:t.ac}}>Top Price Increases</div>
{topIncreases.length===0?<div style={{fontSize:11,color:t.td}}>No increases recorded yet</div>:
topIncreases.map(x=>(
<div key={x.id} onClick={()=>setSelId(x.id)} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${t.bd}`,cursor:"pointer"}}>
<span style={{fontSize:11}}>{x.name}</span>
<div style={{display:"flex",gap:8}}>
<span style={{fontFamily:mn,fontSize:10,color:t.td}}>${fmt$(x.latest.old_price)} → ${fmt$(x.latest.new_price)}</span>
<span style={{fontFamily:mn,fontSize:11,fontWeight:600,color:t.ac}}>+{x.pct.toFixed(1)}%</span>
</div>
</div>))}
</div>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:18}}>
<div style={{fontSize:13,fontWeight:600,marginBottom:12,color:t.gn}}>Top Price Decreases</div>
{topDecreases.length===0?<div style={{fontSize:11,color:t.td}}>No decreases recorded yet</div>:
topDecreases.map(x=>(
<div key={x.id} onClick={()=>setSelId(x.id)} style={{display:"flex",justifyContent:"space-between",padding:"6px 0",borderBottom:`1px solid ${t.bd}`,cursor:"pointer"}}>
<span style={{fontSize:11}}>{x.name}</span>
<div style={{display:"flex",gap:8}}>
<span style={{fontFamily:mn,fontSize:10,color:t.td}}>${fmt$(x.latest.old_price)} → ${fmt$(x.latest.new_price)}</span>
<span style={{fontFamily:mn,fontSize:11,fontWeight:600,color:t.gn}}>{x.pct.toFixed(1)}%</span>
</div>
</div>))}
</div>
</div>

{/* Search */}
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:18,marginBottom:20}}>
<div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Look Up Ingredient</div>
<div style={{position:"relative"}}>
<input value={search} onChange={e=>{setSearch(e.target.value);setSelId(null);}} placeholder="Search by name or brand..." style={{...si,width:"100%"}}/>
{searchResults.length>0&&!selId&&<div style={{position:"absolute",top:"100%",left:0,right:0,background:t.sf,border:`1px solid ${t.bd}`,borderRadius:8,maxHeight:250,overflow:"auto",zIndex:10}}>
{searchResults.map(ig=>{const hasHistory=!!byIng[ig.id];return(
<div key={ig.id} onClick={()=>{setSelId(ig.id);setSearch(ig.n);}} style={{padding:"8px 12px",cursor:"pointer",borderBottom:`1px solid ${t.bd}`,display:"flex",justifyContent:"space-between"}} onMouseOver={e=>e.currentTarget.style.background=t.sfh} onMouseOut={e=>e.currentTarget.style.background="transparent"}>
<span style={{fontSize:12,fontWeight:500}}>{ig.n}</span>
<span style={{fontSize:10,color:hasHistory?t.bl:t.td}}>{hasHistory?`${byIng[ig.id].changes.length} changes`:"no history"}</span>
</div>);})}
</div>}
</div>
</div>

{/* Selected ingredient chart */}
{selId&&selIng&&<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:18}}>
<div style={{fontSize:14,fontWeight:700,marginBottom:4}}>{selIng.n}</div>
<div style={{fontSize:11,color:t.td,marginBottom:16}}>{selIng.b} — {selIng.dist} — Current: <span style={{fontFamily:mn,color:t.gn}}>${fmt$(selIng.cp)}</span></div>

{selSorted.length===0?<div style={{color:t.td,fontSize:12,padding:20,textAlign:"center"}}>No price history for this item yet.</div>:
<>
<div style={{position:"relative",height:180,marginBottom:16,background:t.sf,borderRadius:8,padding:"12px 8px 24px 50px"}}>
<svg width="100%" height="100%" viewBox={`0 0 ${Math.max(selSorted.length*60,200)} 140`} preserveAspectRatio="none">
{selSorted.map((d,i)=>{
const w=Math.max(selSorted.length*60,200);
const x=selSorted.length===1?w/2:i/(selSorted.length-1)*(w-20)+10;
const y=140-((d.new_price-selMin)/selRange)*120-10;
const prevX=i>0?(selSorted.length===1?w/2:(i-1)/(selSorted.length-1)*(w-20)+10):x;
const prevY=i>0?(140-((selSorted[i-1].new_price-selMin)/selRange)*120-10):y;
return(<g key={i}>
{i>0&&<line x1={prevX} y1={prevY} x2={x} y2={y} stroke={t.bl} strokeWidth="2"/>}
<circle cx={x} cy={y} r="4" fill={d.new_price>d.old_price?t.ac:t.gn} stroke={t.cd} strokeWidth="2"/>
</g>);})}
</svg>
<div style={{position:"absolute",top:8,left:4,fontSize:9,fontFamily:mn,color:t.td}}>${fmt$0(selMax)}</div>
<div style={{position:"absolute",bottom:20,left:4,fontSize:9,fontFamily:mn,color:t.td}}>${fmt$0(selMin)}</div>
</div>
<table style={{width:"100%",borderCollapse:"collapse"}}>
<thead><tr style={{background:t.sf}}><th style={sh}>Date</th><th style={sh}>Old</th><th style={sh}>New</th><th style={sh}>Change</th><th style={sh}>Source</th></tr></thead>
<tbody>{[...selSorted].reverse().map((d,i)=>{const pctChg=d.old_price>0?((d.new_price-d.old_price)/d.old_price*100):0;const up=d.new_price>d.old_price;return(
<tr key={i} style={{borderBottom:`1px solid ${t.bd}`}}>
<td style={{...sd,fontSize:11}}>{new Date(d.changed_at).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'2-digit'})}</td>
<td style={{...sd,fontFamily:mn,fontSize:11}}>${fmt$(d.old_price)}</td>
<td style={{...sd,fontFamily:mn,fontSize:11,fontWeight:600,color:up?t.ac:t.gn}}>${fmt$(d.new_price)}</td>
<td style={{...sd,fontSize:10,color:up?t.ac:t.gn}}>{up?"+":""}{pctChg.toFixed(1)}%</td>
<td style={sd}><span style={{fontSize:9,padding:"1px 5px",borderRadius:3,background:d.source==='invoice'?t.blm:"rgba(139,143,158,0.12)",color:d.source==='invoice'?t.bl:t.tm}}>{d.source}</span></td>
</tr>);})}
</tbody></table>
</>}
</div>}
</>}
</div>);
}
